import { motion } from 'framer-motion';
import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';

import RenderIf from '@/components/Common/RenderIf';
import CategoryBadge from '@/components/Layout/Header/Search/Suggestions/Badge/Category';
import Top10 from '@/components/Layout/Header/Search/Suggestions/Badge/Top10';

import { Endpoints } from '@/network';
import { generateUrlForImage } from '@/pages/books/[bookId]';
import { Book } from '@/utils/interfaces/Library/Books';
interface Props {
  bundle?: Book;
  onClickBook?: () => void;
}

const Bundle: FC<Props> = ({ bundle, onClickBook }) => {
  const imageUrl = generateUrlForImage(
    `${process.env.NEXT_PUBLIC_API_READER_URL}/`,
    `${Endpoints.getCoverImagesForBundle}/`,
    `${bundle?._id}`,
  );

  const formattedBooks = () => {
    let tag: string | null = null;

    if (bundle?.type === 'comingSoon') {
      tag = 'COMING SOON';
    } else if (
      moment(bundle?.createdAt).isAfter(moment().subtract(2, 'months'))
    ) {
      tag = 'New';
    } else if (bundle?.featured) {
      tag = 'BESTSELLER';
    }
    return {
      _id: bundle?._id,
      coverImageUrl: generateUrlForImage(
        `${process.env.NEXT_PUBLIC_API_READER_URL}/`,
        `${Endpoints.getCoverImagesForBooks}/`,
        `${bundle?._id}`,
      ),
      title: bundle?.title,
      externalLink: bundle?.externalLink,
      slug: bundle?.slug,
      type: bundle?.type,
      isExternalLink: bundle?.isExternalLink,
      totalPages: bundle?.totalPages,
      author_name: bundle?.author_list?.[0]?.name,
      tag,
      isFree: bundle?.type === 'short',
      topTen: bundle?.topRanking,
    };
  };

  const getInternalHref = () => {
    if (formattedBooks().tag === 'COMING SOON') {
      return `/bundles/${formattedBooks().slug}-${formattedBooks()._id}/`;
    } else if (formattedBooks().isFree) {
      return `/bundles/${formattedBooks().slug}-${formattedBooks()._id}/?short=true`;
    } else {
      return `/bundles/${formattedBooks().slug}-${formattedBooks()._id}/`;
    }
  };
  return (
    <motion.div
      key={bundle?._id}
      layout
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      className='relative sm:w-[160px] w-[140px] sm:min-w-[160px] min-w-[140px] aspect-[160/160] rounded overflow-hidden'
    >
      <Link
        onClick={(e) => {
          e.stopPropagation();
          onClickBook?.();
        }}
        href={getInternalHref()}
        className='relative sm:w-[160px] w-[140px] sm:min-w-[160px] min-w-[140px] aspect-[160/160] rounded overflow-hidden'
      >
        <Image
          width={160}
          height={160}
          className='w-full h-full object-cover'
          src={imageUrl}
          alt='Course'
        />
      </Link>
      <CategoryBadge
        type='BUNDLE'
        className='bg-gradient-to-b from-[#FB4040] to-[#FB4040]'
      />
      <RenderIf condition={bundle?.topRanking}>
        <Top10 className='absolute right-0 top-0' />
      </RenderIf>
    </motion.div>
  );
};

export default Bundle;
